
import { Device } from '../types';
import { mockSmartMeters } from '@/lib/mock-data/energy/smart-meters';
import { mockIoTGateways } from '@/lib/mock-data/energy/gateways';
import { mockVoltageRegulators } from '@/lib/mock-data/energy/voltage-regulators';
import { allEnergyDevices } from '@/components/settings/data/energy-devices';
import { 
  convertSmartMeterToDevice, 
  convertGatewayToDevice, 
  convertRegulatorToDevice,
  convertStaticDevicesToGisDevices 
} from './converters';

/**
 * Generate energy devices with real device IDs
 */
export const getEnergyDevices = (): Device[] => {
  // Process meters and gateways
  const meterDevices = mockSmartMeters.map((meter, index) => 
    convertSmartMeterToDevice(meter, 'Energy', index % 20));
  
  const gatewayDevices = mockIoTGateways.map((gateway, index) => 
    convertGatewayToDevice(gateway, 'Energy', index % 10));
  
  // Add voltage regulators
  const regulatorDevices = mockVoltageRegulators.map((regulator, index) => 
    convertRegulatorToDevice(regulator, index));
  
  // Add static devices from settings
  const staticDevices = convertStaticDevicesToGisDevices(allEnergyDevices, 0);
  
  return [...meterDevices, ...gatewayDevices, ...regulatorDevices, ...staticDevices];
};
